import ErrorState from '@zenbusiness/zui/ErrorState';

import { useQASession } from '#client/hooks/useQASession';
import { BUSINESS_PHASES, useWebinars } from '#client/hooks/useWebinars';

import RunningAndGrowing from './RunningAndGrowing';
import RunningAndGrowingSkeleton from './RunningAndGrowingSkeleton';

function RunningAndGrowingWrapper() {
  const {
    data: webinars, loading, error, refetch
  } = useWebinars(BUSINESS_PHASES.RUNNING_GROWING);

  const {
    data: qaSection, loading: qaLoading, error: qaError, refetch: qaRefetch
  } = useQASession(BUSINESS_PHASES.RUNNING_GROWING);

  if (loading || qaLoading) {
    return <RunningAndGrowingSkeleton />;
  }

  if (error) {
    return <ErrorState onReload={refetch} />;
  }

  if (qaError) {
    return <ErrorState onReload={qaRefetch} />;
  }

  return (
    <RunningAndGrowing
      webinars={webinars}
      qaSection={qaSection}
    />
  );
}

export default RunningAndGrowingWrapper;
